"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayCloseSource = void 0;
var OverlayCloseSource;
exports.OverlayCloseSource = OverlayCloseSource;
(function (OverlayCloseSource) {
  OverlayCloseSource["MODAL_CROSS_CLICK"] = "MODAL_CROSS_CLICK";
  OverlayCloseSource["MODAL_OUTSIDE_CLICK"] = "MODAL_OUTSIDE_CLICK";
  OverlayCloseSource["FLYOUT_CROSS_CLICK"] = "FLYOUT_CROSS_CLICK";
  OverlayCloseSource["FLYOUT_OUTSIDE_CLICK"] = "FLYOUT_OUTSIDE_CLICK";
  OverlayCloseSource["BOTTOMTRAY_CROSS_CLICK"] = "BOTTOMTRAY_CROSS_CLICK";
  OverlayCloseSource["BOTTOMTRAY_OUTSIDE_CLICK"] = "BOTTOMTRAY_OUTSIDE_CLICK";
  OverlayCloseSource["SIDETRAY_CROSS_CLICK"] = "SIDETRAY_CROSS_CLICK";
  OverlayCloseSource["SIDETRAY_OUTSIDE_CLICK"] = "SIDETRAY_OUTSIDE_CLICK";
})(OverlayCloseSource || (exports.OverlayCloseSource = OverlayCloseSource = {}));